import { App } from 'vue';

import { useModal } from '@v1/composables/modal/use-modal';

const modal = useModal();

const MODAL = {
  v1: modal,
};

const ModalPlugin = {
  install(app: App) {
    app.provide('$modal', MODAL);
  },
};

export default ModalPlugin;
